const Status = {
  INACTIVE: { id: 0, name: 'Inativo' },
  ACTIVE: { id: 1, name: 'Ativo' },
  CANCELED: { id: 2, name: 'Cancelado' }
}

Object.freeze(Status)

export default Status